
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'IconArrowLeft',
  props: {
    ariaLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['click'],
  computed: {
    ...mapGetters(['global'])
  }
});
